import { CENTER, EQUIPMENT } from "../constants/mainAPI";
import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import {
    EquipmentDataCreate,
    EquipmentDataEdit,
    EquipmentsSuccessResponse,
    EquipmentSuccessResponse,
} from "../types/api/equipment";
import { toFormData } from "../utils/toFormData";
import { getFileFromUrl } from "../utils/getFileFromUrl";
import { ErrorResponseType } from "../types/api/main";

export const getEquipments = (
    centerId: string | undefined,
    callback?: (resp: EquipmentsSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${EQUIPMENT}`, true, searchParams, callback, errorCallback);
};
export const getEquipment = (
    centerId: string | undefined,
    equipmentId: number | undefined,
    callback?: (resp: EquipmentSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${EQUIPMENT}/${equipmentId}`, true, {}, callback, errorCallback);
};

export const createNewEquipment = async (
    centerId: string | undefined,
    data: EquipmentDataCreate,
    callback?: (resp: EquipmentSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPostRequest(
                `${CENTER}/${centerId || 0}/${EQUIPMENT}`,
                true,
                formData,
                {},
                callback,
                errorCallback,
            );
        });
    } else {
        return doPostRequest(`${CENTER}/${centerId || 0}/${EQUIPMENT}`, true, formData, {}, callback, errorCallback);
    }
};

export const editEquipment = async (
    centerId: string | undefined,
    equipmentId: number | undefined,
    data: EquipmentDataEdit,
    callback?: (resp: EquipmentSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data.delete_photos?.length > 0) {
        data.delete_photos.forEach((v: any, index: Number) => {
            formData.append(`delete_photos[${index}]`, v);
        });
    }
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v?.photo?.file &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPutRequest(
                `${CENTER}/${centerId || 0}/${EQUIPMENT}/${equipmentId}`,
                true,
                formData,
                {},
                callback,
                errorCallback,
            );
        });
    } else {
        return doPutRequest(
            `${CENTER}/${centerId || 0}/${EQUIPMENT}/${equipmentId}`,
            true,
            formData,
            {},
            callback,
            errorCallback,
        );
    }
};

export const deleteEquipment = (
    centerId: string | undefined,
    equipmentId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}/${EQUIPMENT}/${equipmentId}`, true, {}, callback, errorCallback);
};
